// Selector to get the entire eventVendors state
export const selectEventVendorsState = (state) => state.eventVendor;

// Selector to get the loading status for eventVendors actions (list, filter, search)
export const selectEventVendorsLoading = (state) => state.eventVendor?.loading ?? false;

// Selector to get the error for eventVendors actions (list, filter, search)
export const selectEventVendorsError = (state) => state.eventVendor?.error;

// Selector to get the list of eventVendors (includes filtered or search results)
export const selectEventVendorsData = (state) => state.eventVendor?.eventVendors?.data ?? [];

// Selector to get the current page for pagination
export const selectEventVendorsCurrentPage = (state) => state.eventVendor?.eventVendors?.currentPage ?? 1;

// Selector to get the total number of records
export const selectEventVendorstotalRecords = (state) => state.eventVendor?.eventVendors?.totalRecords ?? 0;

// Selector to get the number of items per page
export const selectEventVendorsPageSize = (state) => state.eventVendor?.eventVendors?.pageSize ?? 10;

// Selector to get the next page URL
export const selectEventVendorsNextPageUrl = (state) => state.eventVendor?.eventVendors?.nextPageUrl;

// Selector to get the previous page URL
export const selectEventVendorsPrevPageUrl = (state) => state.eventVendor?.eventVendors?.prevPageUrl;

// Export selectors
export const selectExportLoading = (state) => state.eventVendor?.export?.loading ?? false;
export const selectExportSuccess = (state) => state.eventVendor?.export?.success ?? false;
export const selectExportError = (state) => state.eventVendor?.export?.error;

// View details selectors
export const selectEventVendorDetails = (state) => state.eventVendor?.viewDetails?.data;
export const selectEventVendorDetailsError = (state) => state.eventVendor?.viewDetails?.error;

// Update info selectors
export const selectUpdateEventVendorLoading = (state) => state.eventVendor?.updateInfo?.loading ?? false;
export const selectUpdateInfoSuccess = (state) => state.eventVendor?.updateInfo?.success ?? false;
export const selectUpdateEventVendorError = (state) => state.eventVendor?.updateInfo?.error;

// Add eventVendor selectors
export const selectAddEventVendorLoading = (state) => state.eventVendor?.addEventVendor?.loading ?? false;
export const selectAddEventVendorSuccess = (state) => state.eventVendor?.addEventVendor?.success ?? false;
export const selectAddEventVendorError = (state) => state.eventVendor?.addEventVendor?.error;

// Combined loading selector for any eventVendor action
export const selectEventVendorLoading = (state) => 
  selectAddEventVendorLoading(state) || 
  selectUpdateEventVendorLoading(state) || 
  selectExportLoading(state) ||
  selectEventVendorsLoading(state);

// Combined success selector for add/update actions
export const selectEventVendorActionSuccess = (state) =>
  selectAddEventVendorSuccess(state) || 
  selectUpdateInfoSuccess(state) ||
  selectExportSuccess(state);

// Combined error selector for any eventVendor action
export const selectEventVendorErrors = (state) => ({
  general: selectEventVendorsError(state),
  export: selectExportError(state),
  update: selectUpdateEventVendorError(state),
  add: selectAddEventVendorError(state),
  viewDetails: selectEventVendorDetailsError(state),
});